import { render, staticRenderFns } from "./Penyimpanan.vue?vue&type=template&id=457f9ba2"
import script from "./Penyimpanan.vue?vue&type=script&lang=js"
export * from "./Penyimpanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports